import { $, $$ } from '@/utilities/helpers';

window.dataLayer = window.dataLayer || [];

$$('.instant-search__filter-check').forEach(link => {
    link.addEventListener('click', () => {
        window.dataLayer.push({
            event: 'ui_interaction',
            action: 'search_filter_click'
        });
    });
});

$$('.js-instant-search-input').forEach(link => {
    link.addEventListener('change', () => {
        window.dataLayer.push({
            event: 'ui_interaction',
            action: 'search_input_change'
        });
    });
});

$$('.js-instant-search-sort').forEach(link => {
    link.addEventListener('change', () => {
        window.dataLayer.push({
            event: 'ui_interaction',
            action: 'search_sort_change'
        });
    });
});

$$('.js-header-phone-link').forEach(link => {
    link.addEventListener('click', () => {
        window.dataLayer.push({
            event: 'ui_interaction',
            action: 'phone_click'
        });
    });
});

$$('.js-newsletter-form').forEach(link => {
    link.addEventListener('submit', () => {
        window.dataLayer.push({
            event: 'ui_interaction',
            action: 'newsletter_submit'
        });
    });
});


$$('#UserForm_Form_7').forEach(link => {
    link.addEventListener('submit', () => {
        window.dataLayer.push({
            event: 'ui_interaction',
            action: 'contact_form_submit'
        });
    });
});

